import store from '@/store';

export default class TizenKeyStorage {
  static get(name) {
    try {
      const value = tizen.keymanager.getData({ name });
      if (value !== undefined && value !== null) return value;
    } catch (error) {
      console.log(
        `[TizenKeyStorage] keymanager.getData failed for "${name}": ${error.name} – ${error.message}, trying localStorage fallback`
      );
    }
    // Fallback: localStorage wenn keymanager keinen Wert liefert
    const fallback = localStorage.getItem(name);
    if (fallback !== null) {
      console.log(`[TizenKeyStorage] localStorage fallback: "${name}" = ${fallback}`);
      return fallback;
    }
    return undefined;
  }

  static save(name, value) {
    // Immer parallel im localStorage sichern (Fallback bei keymanager-Verlust)
    try {
      localStorage.setItem(name, value);
    } catch (e) {
      console.log(`[TizenKeyStorage] localStorage.setItem failed for "${name}":`, e);
    }
    return new Promise((resolve) => {
      const callback = () => resolve();
      try {
        this._removeFromKeymanager(name);
        tizen.keymanager.saveData(name, value, null, callback, callback);
      } catch (error) {
        store.dispatch('notification/new', {
          title: 'Save data ' + name,
          message: value,
        });
        resolve();
      }
    });
  }

  static remove(name) {
    try {
      localStorage.removeItem(name);
    } catch (e) {
      console.log(`[TizenKeyStorage] localStorage.removeItem failed for "${name}":`, e);
    }
    this._removeFromKeymanager(name);
  }

  static _removeFromKeymanager(name) {
    try {
      tizen.keymanager.removeData({ name });
    } catch (error) {
      console.log(`[TizenKeyStorage] keymanager.removeData failed for "${name}":`, error);
    }
  }
}



// WEBPACK FOOTER //
// ./src/helpers/StorageHandler/Tizen.js